<template>
    <div id="aprication">
        <div class="headerp-div">
            <div class="header-div">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :key="crumbs" v-for="crumbs in $crumbsList()">{{crumbs}}</el-breadcrumb-item>
                </el-breadcrumb>

            </div>
            <div class="header-div" style="text-align: right">
                <div style="float: right">
                    <el-button size="mini" v-if="$hasPerm('business:dicKm:add')" @click="handleAdd()"
                               style=";background-color:#16E3A1;color: white">新增<i class="el-icon-plus"></i></el-button>
                </div>
                <div style="float: right">
                    <el-button size="mini" @click="handleFind()" style=";background-color:#409EFF;color: white;">查询<i
                            class="el-icon-search"></i></el-button>
                </div>
            </div>
        </div>

        <div style="width: 100%;height: 100%;display:flex;flex-direction:column;">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane :label="item.fna" :name="item.fco" v-for="item in fuZhuTypeList"></el-tab-pane>
            </el-tabs>
        </div>

        <div class="ch_panel" style="height: 460px; overflow: auto;color: #73d7b7">
            <el-table :data="tableData" border size="medium" style="width: 100%">
                <el-table-column prop="fco" label="编码"></el-table-column>
                <el-table-column prop="fna" label="名称"></el-table-column>
                <el-table-column prop="ftyn" label="类型"></el-table-column>
                <el-table-column prop="sta" label="状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.sta=='0'"><span style="color: #35cc5c;">正常</span></span>
                        <span v-if="scope.row.sta=='1'"><span style="color: #f5bb34;">停用</span></span>
                    </template>
                </el-table-column>
                <el-table-column prop="rem" min-width="99" :show-overflow-tooltip="true" label="备注"></el-table-column>
                <el-table-column prop="createTime" label="创建时间"></el-table-column>
                <el-table-column label="操作" v-if="$hasPerm('business:fuZhuXm:edit,business:fuZhuXm:remove')">
                    <template slot-scope="scope">
                        <el-button size="mini" style="margin-right: 6.6px;" v-if="$hasPerm('business:fuZhuXm:edit')"
                                   @click="handleEdit(scope.row)">编辑<i class="el-icon-edit"></i></el-button>
                        <el-popconfirm title="确定删除吗？" @onConfirm="handleDelete(scope.row)">
                            <el-button size="mini" slot="reference" v-if="$hasPerm('business:fuZhuXm:remove')"
                                       type="danger">删除<i class="el-icon-delete"></i></el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    style="margin-top: 5px;"
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"
                    :page-size="pageSize"
                    :current-page="currentPage"
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
            ></el-pagination>
        </div>

        <edit v-if="editVisible" ref="edit" @handleCurrentChange="handleCurrentChange"></edit>
    </div>
</template>
<script>
    import Edit from './edit'

    export default {
        name: 'dicKmList',
        components: {
            Edit
        },
        data() {
            return {
                currentPage: 1, //初始页
                pageSize: 10, //    每页的数据
                total: 0,
                offset: 0,
                tableData: [],
                fuZhuTypeList: [],
                markName: '',
                activeName: '',
                editVisible: false
            }
        },
        methods: {
            handleCurrentChange(cPage) {
                this.offset = (cPage - 1) * this.pageSize;
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/fuZhuXm/list'),
                    method: 'get',
                    params: {
                        'offset': this.offset,
                        'limit': this.pageSize,
                        'fty': this.activeName,
                        'markName': this.markName
                    }
                }).then(r => {
                    if (r.data.code == 0) {
                        this.tableData = r.data.data.rows;
                        this.total = r.data.data.total;
                    } else {
                        this.$message({ // 失败
                            type: 'error',
                            message: r.data.msg
                        })
                    }
                }).finally(r => {
                })

            },
            getFuZhuTypeList() {
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/fuZhuXm/allList'),
                    method: 'get'
                }).then(r => {
                    this.fuZhuTypeList = r.data.data;
                    if (this.fuZhuTypeList != null && this.fuZhuTypeList.length > 1) {
                        this.activeName = this.fuZhuTypeList[0].fco
                        this.handleCurrentChange(1);
                    }
                })
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.handleCurrentChange(1);
            },
            handleClick() {
                this.handleCurrentChange(1);
            },
            handleFind() {
                this.handleCurrentChange(1);
            },
            handleAdd() {
                this.editVisible = true;
                this.$nextTick(() => {
                    this.$refs.edit.int("add",this.activeName);
                })
            },
            handleEdit(row) {
                let id = row.id;
                this.editVisible = true;
                this.$nextTick(() => {
                    this.$refs.edit.int(id,this.activeName);
                })
            },
            handleDelete(row) {
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/fuZhuXm/remove'),
                    method: 'post',
                    data: this.$httpTAG.adornData(row)
                }).then(res => {
                    if (res.data.code == 0) {
                        this.$notify({
                            title: '操作成功！',
                            type: 'success',
                            offset: 600
                        });
                        this.handleCurrentChange(1);
                    } else {
                        this.$message({ // 失败
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                }).finally(r => {
                })
            }
        },
        created: function () {
            this.getFuZhuTypeList();
        }
    }
</script>
<style scoped>
    .header-div {
        margin-bottom: 5px;
        float: left;
        width: 50%;
    }

    .queryInput >>> .el-input__inner {
        border-radius: 0px;
        width: 200px;
    }
</style>